import React from 'react'

const PartFive = () => {
  return (
    <><br/>
        <div className="row">
            <div className="col-xl-12 col-md-12">
                <br/>
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>หมวดที่ 2 ระยะเวลาสัญญา การเริ่มทำงาน และกำหนดแล้วเสร็จของงาน</strong>
                </p> 
            </div>
        </div>
        <div className="row">
            <div className="col-xl-10 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.1 ผู้รับจ้างจะต้องเป็นผู้ออกแบบและจัดทำรายละเอียดของแบบ, รายการก่อสร้างพร้อมยื่นของอนุญาตก่อสร้างต่อหน่วยงานที่เกี่ยวข้องภายในกำหนดเวลา
                </p> 
            </div>
            <div className="col-xl-2 col-md-12">
                <div className="textOnInput mb-4">
                    <label name="section2_assign_agency" htmlFor="inputText">กำหนดเวลา(วัน)</label>
                    <input name="section2_assign_agency" className="form-control shadow-none input-tabs3" autoComplete="off" ></input>
                </div>
            </div>
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    นับจากวันลงนามทำสัญญา ในกรณีที่ผู้ว่าจ้างปรับเปลี่ยนรายละเอียดแบบเพิ่มเติมนอกเหนือสัญญา และมีผลทำให้การจัดทำแบบล่าช้าออกไบ ผู้ว่าจ้างยินยอมให้ ผู้รับจ้างขยายระยะเวลาการทำงานออกไป โดยทางผู้รับจ้างจะทำเอกสารเป็นลายลักษณ์อักษรให้กับผู้ว่าจ้างลงนามรับทราบ
                </p> 
            </div>
        </div>
        <div className="row">
            <div className="col-xl-8 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.2 ทั้งสองฝ่ายตกลงให้สัญญานี้มีกำหนดระยะเวลา
                </p> 
            </div>
            <div className="col-xl-4 col-md-12">
                <div className="textOnInput mb-4">
                    <label name="section2_assign_contract" htmlFor="inputText">กำหนดระยะเวลา(วัน)</label>
                    <input name="section2_assign_contract" className="form-control shadow-none input-tabs3" autoComplete="off" ></input>
                </div>
            </div>
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    โดยเริ่มนับตั้งแต่วันที่ได้รับอนุญาตก่อสร้างอาคารจากเจ้าพนักงานตามกฎหมาย
                </p> 
            </div>
        </div>
        <div className="row">
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.3 หากผู้รับจ้างทำงานไม่แล้วเสร็จตามสัญญา ผู้รับจ้างตกลงให้ผู้ว่าจ้างคิดค่าปรับในอัตราร้อยละศูนย์ จุดศูนย์หนึ่งของราคาการรับจ้างก่อสร้างอาคาร โดยปรับเป็นรายวัน นับแต่วันที่ล่าวงเลยกำหนดระยะเวลาตามสัญญา
                </p> 
            </div>
        </div>
        <div className="row">
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.4 ในกรณีที่ผู้รับจ้างไม่สามารถลงมือทำงานตามข้อ 2.2 ได้เนื่องจากเกิดเหตุใดๆ ที่มิอาจหลีกเลี่ยงได้และเป็นเหตุให้การก่อสร้างต้องหยุดชะงักลง โดยมิใช่ความผิดของผู้รับจ้าง หรือมีพฤติการณ์ที่ผู้รับจ้างไม่ต้องรับผิดชอบ ให้ผู้ว่าจ้างขยายระยะเวลาแล้วเสร็จตามสัญญาออกไปเท่ากับเวลาที่เสียไปเพราะเหตุดังกล่าว หากเหตุใดๆ ตามวรรคแรกเกิดจากการกระทำของผู้ว่าจ้าง เป็นเหตุให้ผู้รับจ้างต้องหยุดงานเกินกว่า 30 วัน หรือ การก่อสร้างตามสัญญามิอาจกระทำต่อไปได้ อันเนื่องมาจากเหตุสุดวิสัย เช่น ที่ดินถูกเวนคืน ความเสียหายเกิดจากวาตภัย, อัคคีภัย, อุทกภัย, แผ่นดินไหว หรือ การให้ผู้มูล การชี้หลักเขต สภาพและที่ตั้งของที่ดินผิดพลาด ฯลฯ ผู้รับจ้างจะใช้สิทธิบอกเลิกสัญญาก็ได้ และผู้ว่าจ้างยินยอมชำระค่าก่อสร้างให้แก่ผู้รับจ้าง ตามมูลค่าของงวดงานในสัญญาที่ได้ก่อสร้างไปแล้ว
                </p> 
            </div>
        </div>
        <div className="row">
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.5 หากผู้รับจ้างประสบอุปสรรคในการก่อสร้างซึ่งผู้ว่าจ้างมิได้คาดคิดมาก่อน เช่น สิ่งกีดขวางที่ผยู่ใต้ดิน การปิดถนนเข้าสู่บริเวณก่อสร้าง ฯลฯ และอุปสรรคดังกล่าวทำให้ผู้รับจ้างต้องเสียค่าใช้จ่ายเพิ่มขึ้น ผู้ว่าจ้างยินยอมชุดใช้ค่าใช้จ่ายที่เพิ่มขึ้นแก่ผู้รับจ้างตามความเป็นจริง
                </p> 
            </div>
        </div>
    </>  
  )
}

export default PartFive